import { Media } from "reactstrap";
import { ImageProps } from "../types/CoreComponents";

export const Image: React.FC<ImageProps> = (props) => {
    return <Media {...props} alt={props.alt ? props.alt : "image"} loading="lazy" />;
};  

